<div style="height: 100%; display: flex; flex-direction: row; gap: 10px;">
    <div class="col-2 left-pane">
        <ng-content select="[layout-left]"></ng-content>
    </div>

    <div class="col-6 center-pane">
        <ng-content select="[layout-center]"></ng-content>
    </div>

    <div class="col right-pane">
        <ng-content select="[layout-right]"></ng-content>
    </div>
</div>
